import { useEffect } from "react"
import { Outlet, useNavigate } from "@tanstack/react-router"
import { useAuth, useRedirectAfterLogin } from "@/auth"
// Wraps the routes for signed-out users, despite the name.
export default function AuthRoute() {
  const { isLoading, isAuthenticated } = useAuth()
  const { getRedirectUrl } = useRedirectAfterLogin()
  const navigate = useNavigate()

  useEffect(() => {
    if (isLoading) {
      return
    }
    if (isAuthenticated) {
      void navigate({ to: getRedirectUrl(), replace: true })
    }
  }, [isLoading, isAuthenticated, navigate, getRedirectUrl])

  return (
    <div className="flex flex-col items-center px-8 py-24">
      <div className="w-full sm:w-2/3 md:w-1/2">
        <Outlet />
      </div>
    </div>
  )
}
